import VolumeRegistrationScreen from './VolumeRegistrationScreen';
export default VolumeRegistrationScreen;
